import React from "react";
import Tooltip from "../../../Tooltip";
import { jsx as _jsx } from "react/jsx-runtime";
var wrapper = function wrapper(children, tooltipContent) {
  return /*#__PURE__*/_jsx(Tooltip, {
    content: tooltipContent,
    children: /*#__PURE__*/_jsx("span", {
      children: children
    })
  });
};
function ConditionalTooltipWrapper(_ref) {
  var tooltipContent = _ref.tooltipContent,
    children = _ref.children;
  return tooltipContent ? wrapper(children, tooltipContent) : children;
}
export default ConditionalTooltipWrapper;